/*
 * Module for the contents button on the dashboard
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/dashboard/dashboardContents/dashboardContentsView",
], function (Marionette, Messenger, DashboardContentsView) {
  var DashboardContentsController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "dashboardContents";
      this.region = options.region;
    },
    show: function (localeId) {
      //get the counts of the missing/modified/new content urls using the reqres from contentsModel.js
      var counts = Messenger.reqres.request("content:awareness:count", localeId);
      this.view = new DashboardContentsView.dashboardContentsView({ model: counts });

      //show the contents page with a list of missing content
      this.view.on(
        "click:missing:content",
        function () {
          //no need to save because there's nothing to save on the dashboard
          Messenger.vent.trigger("show:contents");
          //trigger the missing content search
          Messenger.vent.trigger("missing:content:search", localeId);
        },
        this,
      );

      //show the contents page with a list of modified content
      this.view.on(
        "click:modified:content",
        function () {
          //no need to save because there's nothing to save on the dashboard
          Messenger.vent.trigger("show:contents");
          //trigger the modified content search
          Messenger.vent.trigger("modified:content:search", localeId);
        },
        this,
      );

      //deal with new content--TBD
      this.view.on("click:new:content", function () {}, this);
      this.showRegion(this.view);
    },
  });

  return DashboardContentsController;
});
